import {Divider, Grid, TextField, Typography} from '@material-ui/core';
import {changeBeneficiaryPercent, validateBeneficiaryPercent} from 'Beneficiaries/ducks/beneficiaryForm';
import {BeneficiaryPerson} from 'Beneficiaries/models/BeneficiaryPerson';
import React from 'react';
import {useDispatch} from 'react-redux';

export type BeneficiaryPercentageProps = {
  beneficiaries: BeneficiaryPerson[];
  title: string;
  disabled: boolean;
  hasError: boolean;
};

const BeneficiaryPercentage = ({beneficiaries, title, disabled, hasError}: BeneficiaryPercentageProps) => {
  const dispatch = useDispatch();
  const errorMessage = 'Percentages does not add up to 100';

  return beneficiaries.length > 0 ? (
    <>
      <Divider className="beneficiary_form__divider" />
      <Grid item xs={12}>
        <Typography variant="h6" className="beneficiary_form__title">
          {title}
        </Typography>
      </Grid>
      {beneficiaries.map((beneficiary, index) => {
        const fullName =
          `${beneficiary.firstName || ''} ${beneficiary.middleName || ''} ${beneficiary.lastName || ''}`.trim() ||
          `Beneficiary ${index + 1}`;

        return (
          <Grid item container xs={12} key={beneficiary.id}>
            <Grid item container xs={12} md={6} justify="center" alignItems="center">
              <Grid item>
                <Typography variant="subtitle1">{fullName}</Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                type="number"
                InputProps={{inputProps: {min: 0, max: 100, step: 1}}}
                variant="outlined"
                label="Beneficiary Percentage"
                value={beneficiary?.beneficiaryPercent || 0}
                onChange={e => dispatch(changeBeneficiaryPercent(parseInt(e.target.value, 10), beneficiary?.id))}
                onBlur={() => dispatch(validateBeneficiaryPercent())}
                required
                disabled={disabled}
                error={hasError}
                helperText={hasError && errorMessage}
              />
            </Grid>
          </Grid>
        );
      })}
    </>
  ) : (
    <div />
  );
};

export default BeneficiaryPercentage;
